const imageWidthMapping = {
  full_1: 100,
  half_2: 50,
  one_fourth_4: 25,
  one_third_3: 33.33
};
const dynamicImagePlacement = (enable_dynamic_row_config, dynamic_row_config, image_type, isMobile, isTablet) => {
  if (enable_dynamic_row_config) {
    if (isMobile) {
      return imageWidthMapping[`${dynamic_row_config == null ? void 0 : dynamic_row_config.small_viewport}`];
    } else if (isTablet) {
      return imageWidthMapping[`${dynamic_row_config == null ? void 0 : dynamic_row_config.medium_viewport}`];
    } else {
      return imageWidthMapping[`${dynamic_row_config == null ? void 0 : dynamic_row_config.large_viewport}`];
    }
  } else {
    return imageWidthMapping[`${image_type}`];
  }
};
export {
  dynamicImagePlacement,
  imageWidthMapping
};
